import type { EquipmentAccessorialType } from './constants.ts'
import { createEquipmentCategory, defaultAccessorials } from './internal.ts'

const straightTruckAccessorials: EquipmentAccessorialType[] = [
  ...defaultAccessorials,
  'liftgate',
  'straps',
]

export const straightTruckEquipment = createEquipmentCategory(
  {
    bucket: 'straight-truck',
    mode: 'truckload',
    workflows: ['truckload', 'ltl'],
    accessorialTypes: straightTruckAccessorials,
  },
  [
    { key: 'straight-truck-20', name: "Straight truck 20'" },
    { key: 'straight-truck-26', name: "Straight truck 26'" },
  ],
)
